import {useEffect, useState} from "react";
import Api from "../../services/Api.ts";
import { useAtom } from 'jotai';
import { selectedDepartmentsAtom } from '../../jotai_state';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, LineElement, Title, Tooltip, Legend } from 'chart.js';
import FilterClients from "../../components/FilterClients/FilterClients.tsx";

ChartJS.register(CategoryScale, LinearScale, LineElement, Title, Tooltip, Legend);


interface KpiLogInterface {
  id: string;
  date: string;
  value: number;
}

interface KpiInterface {
  id: string;
  name: string;
  kpiType: string;
  kpiLogs: Array<KpiLogInterface>;
}


export default function Kpi() {
  const api = Api.getInstance();

  const [selectedDepartments] = useAtom(selectedDepartmentsAtom);
  const [kpis, setKpis] = useState<Array<KpiInterface>>([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    getData();
  }, [selectedDepartments]);

  const getData = () => {
    const data = {
      departments: selectedDepartments,
    }

    api.post('customer/kpi', data).then((response) => {
      setKpis(response.json.data.kpis)
      setLoaded(true);
    })
  }

  const getLabels = (kpi: KpiInterface)  => {
    const labels = [];
    for (const l of kpi.kpiLogs) {
      labels.push(l.date);
    }
    return labels;
  }

  const getDataPoints = (kpi: KpiInterface)  => {
    const data = [];
    for (const l of kpi.kpiLogs) {
      data.push(l.value);
    }
    return data;
  }

  const renderMain = () => {
    if (!loaded) {
      return <div>Loading data...</div>
    }
    return (
      <div>

        <div className="mt-4 z-h1">KPI:s</div>

        <div className="mt-4 z-box">
          {
            kpis.map(kpi => {
              const labels = getLabels(kpi);
              const data = getDataPoints(kpi);
              return (
                <div key={"kpi_" + kpi.id}>

                  <p className="z-h2 mb-4 text-neutral-800">{kpi.name}</p>

                  {
                    data.length > 0 ? (
                      <Line
                        data={{
                          labels: labels,
                          datasets: [{
                            data: data,
                            backgroundColor: '#57733F',
                          }],
                        }}
                        options={{
                          responsive: true,
                          scales: {y: {min: 0, ticks: {callback: (v) => v + '%'}}},
                          plugins: { legend: { display: false } },
                        }}
                      />
                    ) : (
                      <div className="z-body2">Found no entered KPI values for this combination.</div>
                    )
                  }
                </div>
              )
            })
          }
        </div>
      </div>
    )
  }

  return (
    <div className="content-wide">
      <FilterClients/>
      <div className="px-8 py-4">
        {renderMain()}
      </div>
    </div>
  );
}